// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1YGK-","notes":"Notes_notes__2excU"};